import React, { forwardRef, useRef, useEffect, useState, Suspense } from "react"
import { useFrame } from "@react-three/fiber"
import Video from "./Video"
import lerp from "lerp"
import "./CustomMaterial"
import { useBlock } from "../blocks"
import useContentStore from "../redux/stores/contentStore"

const Plane = forwardRef(({ color = "white", shift = 1, opacity = 1, args, map, video, ...props }, ref) => {
  const content = useContentStore((state) => state.content)
  const { viewportHeight, offsetFactor } = useBlock()
  const material = useRef()
  let last = content.top.current

  useFrame(() => {
    const { pages, top } = content
    if(material.current){
        material.current.scale = lerp(material.current.scale, offsetFactor - top.current / ((pages - 1) * viewportHeight), 0.1)
        material.current.shift = lerp(material.current.shift, ((top.current - last) / shift) * 1.5, 0.1)
        last = top.current
    }
  })

  const materialElem = (() => {
      return video ?
        <Video material={material} fallback="ph1.jpg" video={video}/> :
        <customMaterial ref={material} color={color} map={map} transparent opacity={opacity} />
  })();

  return (
      <mesh ref={ref} {...props}>
        <planeGeometry args={args}/>
        {materialElem}
      </mesh>
  );
})

export default Plane
